import PropTypes from 'prop-types';
// @mui
import { styled, useTheme } from '@mui/material/styles';
import {
  Box,
  ButtonBase, Paper,
} from '@mui/material';




const PopoverStyle = styled(Box)(
    ({ theme }) => `
      position: relative;
      .Sim-menu-header{
        svg {
          transition: all .4s ease
        };
      };
      .Sim-menu-content{
        min-width: 100px;
        padding: 0px;
        position: absolute;
        top: 100%;
        z-index: -1;
        transition: all .3s ease;
        // transform: scaleY(0);
        transform-origin: top center;
        opacity: 0;
        visibility: hidden;
        text-align: left;
        border-radius: 4px;
        box-shadow: 0px 6px 8px 0px rgba(0, 0, 0, 0.12);
      };
      
      &:hover{
        .Sim-menu-header{
          // &:after {
          //   width: 100%;
          // };
          // svg {
          //   fill: ${theme.palette.action.selected};
          //   color: ${theme.palette.action.selected};
          // };
        };
        .Sim-menu-content{
          z-index: 10;
          transform: scaleY(1);
          opacity: 1;
          visibility: visible;
        }
      }
    `
);
IconPopover.propTypes = {
    children: PropTypes.node,
    primary: PropTypes.node,
    content: PropTypes.node,
    position: PropTypes.object,
};
export function IconPopover({ primary, children, content, position = { x: '0px', y: '0px' }, disabledHoverLine = false }) {
    const theme = useTheme();
    return (
        <PopoverStyle sx={{
          ...(!disabledHoverLine ? theme.typography.hoverSecondaryUnderline2px : {}),
        }}>
            <ButtonBase
                className={'Sim-menu-header'}
                disableRipple
                sx={{
                    height: '100%',
                    py: 0,
                    px: 1.5,
                    borderRadius: 0,
                    transition: 'all .4s ease',
                    willChange: 'revert',
                    // ...(!disabledHoverLine ? theme.typography.hoverSecondaryUnderline2px : {}),
                }}
            >
                { primary || children }
            </ButtonBase>
            <Paper className={'Sim-menu-content'} sx={{ left: position.x || 0 }}>
               { content }
            </Paper>
        </PopoverStyle>
    )
}